import React from "react"

import MarkdownHelper from '../../utils/MarkdownHelper'
import ReactMarkdown from "react-markdown"

import PartnerLogo from '../../subcomponents/PartnerLogo'
import Flag from '../../subcomponents/Flag'
import ViewToggle from '../../subcomponents/ViewToggle'
import { FootnotesFromContext } from "../../subcomponents/Footnotes";

const TopOffer = ({campaign, partnerLogo, flagFilter, logoFilter, isMobile, footnotesWarningText}) => {
    const renderTopOffer = () => {
        return (
            <div className="ad-cp-top-offer hr-bottom bg-white px-md py-md border">
                {['Alle', 'E-Mail'].some(val => flagFilter.includes(val)) &&
                    <div className="flag-container">
                        <Flag text={campaign.flagstoerer} appearance={campaign.flageye_catcher} />
                    </div>
                }
                <div className="ad-cp-top-offer__image mr-md">
                    <img alt="image_top_offer"
                         src={campaign.image_3_2} />
                </div>
                <div className="ad-cp-top-offer__content flex-fill">
                    <h4 className="ad-cp-top-offer__content__title-caption">
                        <ReactMarkdown {...MarkdownHelper.basicTypes()}
                                       source={campaign.title_caption}
                                       escapeHtml={false} />
                    </h4>
                    <h2 className="ad-cp-top-offer__content__title-long">
                        <ReactMarkdown {...MarkdownHelper.headingTypes()}
                                       source={campaign.title_2_short}
                                       escapeHtml={false} />
                    </h2>
                    <p className="my-0 noBolder">
                        <ReactMarkdown {...MarkdownHelper.allTypes()}
                                       source={campaign.copy_short} />
                    </p>

                    <div className="d-flex justify-content-between">
                         <div className="my-md">
                             <button className="btn mam-rnd-btn mam-rnd-btn--mailing">
                                 {campaign.button_cta_external}
                             </button>
                         </div>
                        {
                            logoFilter.includes('E-Mail Logo verbergen') ?
                                '' :
                                <div className="my-sm">
                                    <div className="mailing-partner-logo d-flex">
                                        <PartnerLogo logo={partnerLogo} />
                                    </div>
                                </div>
                        }
                     </div>
                 </div>
            </div>
        )
    }

    return (
        <div className="mailing-type mailing-spacers">
            <ViewToggle isMobile={isMobile('email')}
                        desktopClasses={'mailing-view mb-md'}
                        mobileClasses={'mobile-mailing-view mb-md'}>
                {renderTopOffer()}
                <FootnotesFromContext showWarningText={footnotesWarningText} />
            </ViewToggle>
        </div>
    )
}

export default TopOffer;



// WEBPACK FOOTER //
// ./src/components/ads/mailing/TopOffer.js